// extracted by mini-css-extract-plugin
module.exports = {"container":"OnboardingLayout_container__EFoop","content":"OnboardingLayout_content__y4Vq1","wrapper":"OnboardingLayout_wrapper__9N77U","aside":"OnboardingLayout_aside__QVE3K"};